<eiq-card [style]="isSelected$() ? 'primary' : 'light'" [clickable]="clickable$()" [testId]="testId$()" (clicked)="clicked.emit()">
  <div class="eiq-card-padding eiq-selectable-card" slot="content">
    <span class="eiq-selectable-card__content">
      <span class="fs__md fw__500" [ngClass]="isSelected$() ? 'selected' : ''">
        <ng-content select="[slot=title]"></ng-content>
      </span>
      <span class="fs__xs">
        <ng-content select="[slot=subtitle]"></ng-content>
      </span>
    </span>
    <span class="eiq-selectable-card__icon">
      <ng-content select="[slot=action]"></ng-content>
    </span>
  </div>
</eiq-card>
